import React from "react";
import { PageNewPymesFrame } from "../Components/Page_New_pymes/PageNewPymes";


export const NewPagePymes = () => {

    return (
        <>
           <PageNewPymesFrame></PageNewPymesFrame>
        </>
    )
}
